import { render, staticRenderFns } from "./Hizmet.vue?vue&type=template&id=15f4fc95&scoped=true&"
import script from "./Hizmet.vue?vue&type=script&lang=js&"
export * from "./Hizmet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f4fc95",
  null
  
)

export default component.exports